export const environment = {
  clientId: 'drr-web.qa',
  additionalCookieDomain: true,
  configTools: true,
  description: 'QA build',
  displayVersion: true,
  optimize: false,
  log: true,
  baseURL: 'https://gatewayers-qa.national.aaa.com',
  openAARsURL: 'https://tdr.aaa.com/tdrl/search.jsp',
  ipInterrogateURL:
    'https://certservices.national.aaa.com/RESTWS/aaa/services/geo/locate',
  association: 'AAA',
  googleCaptchaKey: process.env['GOOGLE_RECAPTCHA_API_KEY'],
  googleCaptchaV3Key: process.env['GOOGLE_RECAPTCHA_V3_API_KEY'],
  unsecureClub: '999',
  hotjar: '2789441',
  thirdPartyCookiesUrl: 'https://dfkfmvngo6zht.cloudfront.net/v1.html',
  nativeAppView: false,
  homeBackButtonRedirectTo: '/home',
  awsLocationMapsURL: 'https://maps.geo.us-east-1.amazonaws.com/v2',
  awsLocationApiKey: process.env['DRR_AWS_LOCATION_API_KEY'],
}
